import { Reveal, Eyebrow } from "./Reveal";

const POINTS = [
  { title: "Custom, Not Cookie-Cutter", copy: "Every website is designed around the individual business rather than forcing your brand into a generic template." },
  { title: "Fast Development", copy: "AI-assisted tools allow me to move quickly from concept to working website while still refining the details manually." },
  { title: "Mobile-First Experience", copy: "Your customers use phones. Your website needs to work beautifully on them." },
  { title: "Direct Communication", copy: "You work directly with the person designing and developing your website." },
];

export default function Why() {
  return (
    <section id="why" data-testid="why-section" className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
      <Reveal>
        <div className="flex items-baseline gap-4">
          <span className="font-heading text-xl text-accent">05</span>
          <Eyebrow>Why Work With Me</Eyebrow>
        </div>
        <h2 className="mt-6 font-heading font-medium tracking-tight leading-[1.02] text-4xl sm:text-5xl lg:text-6xl text-ink max-w-2xl">
          A developer who treats your business like her own.
        </h2>
      </Reveal>

      <div className="mt-14 md:mt-20 grid sm:grid-cols-2 border-t border-l border-line">
        {POINTS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.06}>
            <div data-testid={`why-point-${i + 1}`} className="h-full border-b border-r border-line p-8 md:p-12">
              <span className="block h-px w-10 bg-accent" aria-hidden="true" />
              <h3 className="mt-5 font-heading text-2xl md:text-3xl font-medium uppercase tracking-tight text-ink">
                {p.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-stone">{p.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
